import type { FunctionComponent } from 'react';
import { Link } from 'react-router';

import { useApplicationContext } from '~/shared/context/use-application-context';

export const CompanyLogo: FunctionComponent = () => {
    const { applicationState } = useApplicationContext();
    const companyLogoUrl = applicationState.customization.get('uiConfiguration').get('assets').get('companyLogoUrl');

    if (companyLogoUrl.isJust) {
        return (
            <Link className="inline-flex w-[100px] max-w-full items-center justify-center" to="/">
                <img
                    alt="Company logo"
                    className="block max-h-[45px] max-w-full object-contain dark:drop-shadow-[0_0_1px_var(--color-white-200)]"
                    src={companyLogoUrl.value.href}
                />
            </Link>
        );
    }

    return null;
};
